<template>
  <div>
    <div class="container">
      <ul class="checkout-progress-bar">
        <li :class="{ active: currentStep === 1 }">
          <span>{{ translations.delivery }}</span>
        </li>
        <li :class="{ active: currentStep === 2 }">
          <span>{{ translations.payment }}</span>
        </li>
      </ul>
      <div class="row" v-if="currentStep === 1">
        <div class="col-lg-8">
          <ul class="checkout-steps">
            <li>
              <h2 class="step-title">{{ translations.deliveryAddress }}</h2>
              <div class="shipping-step-addresses" v-if="addresses.length">
                <div
                  class="shipping-address-box"
                  :class="{ active: selectedAddress && selectedAddress.id === address.id }"
                  v-for="address in addresses"
                  :key="address.id"
                  @click="selectAddress(address)"
                >
                  <address>
                    {{ address.user }} <br />
                    {{ address.address }} <br />
                    {{ address.town }}, {{ address.country }}, {{ address.zipCode }} <br />
                    {{ address.country }} <br />
                    {{ address.phoneNumber }} <br />
                  </address>
                  <div class="address-box-action clearfix">
                    <button class="btn btn-sm btn-outline-secondary float-right">
                      {{ translations.deliverHere }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="alert alert-warning mt-1">
                  {{ translations.deliveryAddressValidationMessage}}
                </div>
                <router-link
                  :to="{ name: 'NewAddress' }"
                  class="btn btn-sm btn-outline-secondary btn-new-address"
                >
                  {{ translations.newAddress }}
                </router-link>
              </div>
              <local-pagination :action="actionName" :pagination-props="paginationProps" />
            </li>

            <li>
              <div class="checkout-step-shipping">
                <h2 class="step-title">{{ translations.deliveryMethod }}</h2>
                <table class="table table-step-shipping">
                  <tbody>
                    <tr v-for="post in posts" :key="post.id">
                      <td v-if="calculateDeliveryPrice(post) != null">
                        <div class="custom-control custom-radio d-flex my-0">
                          <input
                            :id="post.id"
                            :value="post.id"
                            name="shipping-method"
                            type="radio"
                            class="custom-control-input"
                            @click="setDeliveryType(2)"
                            v-model="expressPostId"
                          />
                          <label class="custom-control-label-radio">{{ post.title }}</label>
                        </div>
                      </td>
                      <td v-if="calculateDeliveryPrice(post) != null">
                        <strong>
                          <span v-if="freeShippingEnabled === true
                            && (freeShippingAmount <= cart.totalAmount || post.price === 0)">
                            {{ translations.free }}*
                          </span>
                          <span v-else> {{ post.price.toFixed(2).replace(".", ",") }} KM </span>
                        </strong>
                      </td>
                      <td v-if="calculateDeliveryPrice(post) != null">
                        {{ translations.deliveryTime }}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="custom-control custom-radio d-flex my-0">
                          <input
                            @click="setDeliveryType(1)"
                            type="radio"
                            id="delivery-1"
                            name="shipping-method"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label-radio">
                            {{ translations.personalPickup }}
                          </label>
                        </div>
                      </td>
                      <td><strong>{{ translations.free }}</strong></td>
                      <td>{{ translations.personalVisitToTheBranch }}</td>
                    </tr>
                    <tr>
                      <td>
                        <div class="custom-control custom-radio d-flex my-0">
                          <input
                            @click="setDeliveryType(3)"
                            type="radio"
                            id="delivery-3"
                            name="shipping-method"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label-radio">
                            {{ translations.ourDelivery }}
                          </label>
                        </div>
                      </td>
                      <!-- 3 -->
                      <td><strong>{{ translations.free }}</strong></td>
                      <td>{{ translations.deliverySevenDays }}</td>
                    </tr>
                  </tbody>
                </table>
                <span class="text-muted" v-if="freeShippingEnabled === true">
                  {{ translations.orderAmountFromText }}
                  {{ freeShippingAmount }}
                  {{ translations.getFreeDeliveryText }}
                </span>
              </div>
              <div class="row" v-if="currentStep === 1">
                <div class="col-lg-12">
                  <div class="checkout-steps-action">
                    <button
                      @click="nextStep()"
                      :disabled="nextStepDisabled"
                      class="btn btn-primary float-right"
                    >
                      {{ translations.nextStep }}
                    </button>
                  </div>
              </div>
            </div>
              <!-- End .checkout-step-shipping -->
            </li>
          </ul>
        </div>
        <!-- End .col-lg-8 -->
        <div class="col-lg-4">
          <div class="order-summary mb-1">
            <h3>{{ translations.shoppingCart }}</h3>
            <h4 v-if="cart && cart.cartItems">
              <a
                data-toggle="collapse"
                href="#order-cart-section"
                class="collapsed"
                role="button"
                aria-expanded="true"
                aria-controls="order-cart-section"
              >
                {{ cart.cartItems.length }} {{ translations.articlesInShoppingCart }}
              </a>
            </h4>
            <div class="collapse show" id="order-cart-section" v-if="cart && cart.cartItems">
              <table class="table table-mini-cart">
                <tbody>
                  <tr v-for="item in cart.cartItems" :key="item.id">
                    <td class="product-col">
                      <figure class="product-image-container">
                        <router-link
                          class="product-image"
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.article) }
                          }"
                        >
                          <Photo
                            :src="`${baseUrl}${item.highlightedImageUrl}`"
                            v-if="item.highlightedImageUrl"
                          />
                          <Photo src="assets/images/no-image.jpg" v-else />
                        </router-link>
                      </figure>
                      <div>
                        <h2 class="product-title">
                          <router-link
                            :to="{
                              name: 'Article',
                              params: { id: item.articleId, slug: slugify(item.article) }
                            }"
                          >
                            {{ item.article }}
                          </router-link>
                        </h2>
                        <span class="product-qty">
                          {{ translations.quantity }}: {{ item.quantity }}</span>
                      </div>
                    </td>
                    <td v-if="canViewPrices" class="price-col">
                      {{ item.totalAmount.toFixed(2).replace(".", ",") }} KM
                    </td>
                  </tr>
                </tbody>
                <tfoot class="custom-table-footer">

                  <!-- novi -->
                  <tr v-if="canViewPrices && cart && cart.cartItems">
                    <td>{{ translations.orderTotalAmountWithoutVat }}</td>
                    <td class="text-right" v-if="cart">
                      {{ cart.totalAmountWithoutVat.toFixed(2) }} KM
                    </td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems">
                  <td>+ {{ translations.tax }}:</td>
                  <td class="text-right">
                    {{
                      cart.totalAmountVat.toFixed(2)
                    }} KM
                  </td>
                </tr>
                <tr style="border-top: 1px solid #ccc;"
                v-if="canViewPrices && cart && cart.cartItems
                  && cart.promoCode
                  && cart.promoCode.discountApplianceType === 1">
                    <td>{{ translations.totalWithVat }}</td>
                    <td class="text-right" v-if="cart && cart.cartItems">
                      {{ (cart.totalAmountWithoutVat + cart.totalAmountVat)
                      .toFixed(2).replace('.', ',') }} KM
                    </td>
                  </tr>
                  <tr v-if="canViewPrices && cart.promoCode
                    && cart.promoCode.discountApplianceType === 1">
                    <td>- {{ translations.promoCode }}</td>
                    <td class="text-right">-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                  </tr>
                  <tr style="border-top: 1px solid #ccc;" v-if="canViewPrices && cart.giftCard">
                    <td>{{ translations.totalWithVat }}</td>
                    <td class="text-right" v-if="cart && cart.cartItems">
                      {{ (cart.totalAmountWithoutVat + cart.totalAmountVat)
                      .toFixed(2).replace('.', ',') }} KM
                    </td>
                  </tr>
                  <tr v-if="cart.giftCard">
                    <td>- {{ translations.giftCard }}</td>
                    <td class="text-right">-{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems"
                  style="border-top: 1px solid #ccc;">
                    <td>{{ translations.totalWithVat }}</td>
                    <td class="text-right">
                      {{ cart.totalAmount.toFixed(2).replace('.', ',') }} KM
                    </td>
                  </tr>
                  <tr>
                    <td>{{ translations.orderTotalBruttoWeight }}</td>
                    <td class="text-right" v-if="cart">
                      {{ cart.totalBruttoWeight.toFixed(2).replace(".", ",") }} KG</td>
                  </tr>
                  <!-- kraj novi -->

                  <!-- <tr v-if="canViewPrices && cart && cart.cartItems &&
                  (!cart.promoCode ||
                    (cart.promoCode && cart.promoCode.discountApplianceType !== 1))">
                    <td>Ukupno narudžba (bez PDV):</td>
                    <td class="text-right">{{ (cart.totalAmountWithoutVat
                      + cart.giftCardDiscount).toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems && cart.promoCode
                    && cart.promoCode.discountApplianceType === 1">
                    <td>Ukupno narudžba (bez PDV):</td>
                    <td class="text-right">{{ (cart.totalAmountWithoutVat + cart.promoDiscount
                      + cart.giftCardDiscount).toFixed(2) }} KM</td>
                  </tr>
                  <tr style="border-bottom: 1px solid #ccc;" v-if="canViewPrices && cart.promoCode
                    && cart.promoCode.discountApplianceType === 1">
                    <td>- {{ translations.promoCode }}</td>
                    <td class="text-right">-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                  </tr>
                  <tr  v-if="canViewPrices && cart.promoCode
                    && cart.promoCode.discountApplianceType === 1">
                    <td>{{translations.totalWithoutVat2}}:</td>
                    <td class="text-right">{{ cart.totalAmountWithoutVat.toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart.giftCard"
                    style="border-bottom: 1px solid #ccc;" >
                    <td>- {{ translations.giftCard }}</td>
                    <td class="text-right">{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems && cart.giftCard">
                    <td>{{translations.totalWithoutVat2}}:</td>
                    <td class="text-right">{{ cart.totalAmountWithoutVat.toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems && cart.giftCard"
                    style="border-bottom: 1px solid #ccc;">
                    <td>+ {{ translations.tax }}:</td>
                    <td class="text-right">{{ cart.totalAmountVat.toFixed(2) }} KM</td>
                  </tr>
                  <tr v-if="canViewPrices && cart && cart.cartItems && !cart.giftCard"
                    style="border-bottom: 1px solid #ccc;">
                    <td>+ {{ translations.tax }}:</td>
                    <td class="text-right">{{ cart.totalAmountVat.toFixed(2) }} KM</td>
                  </tr>
                  <tr>
                    <td>{{ translations.totalWithVat }}</td>
                    <td class="text-right"
                    v-if="cart && cart.cartItems">{{cart.totalAmount.toFixed(2) }} KM</td>
                  </tr>
                  <tr>
                    <td>Ukupna kilaža</td>
                    <td class="text-right" v-if="cart">
                      {{ cart.totalBruttoWeight.toFixed(2).replace(".", ",") }} KG</td>
                  </tr> -->
                </tfoot>
              </table>
            </div>
            <!-- End #order-cart-section -->
          </div>
          <div v-if="cart.promoCode
            && cart.promoCode.discountApplianceType !== 1"
            class="d-flex justify-content-center align-items-center">
              <span>
                {{ translations.promoCodeDiscount }} {{ cart.promoDiscount.toFixed(2) }} KM
              </span>
          </div>
          <!-- End .order-summary -->
        </div>
        <!-- End .col-lg-4 -->
      </div>

      <div class="row" v-if="currentStep === 2">
        <div class="container">
          <div class="row">
            <div class="col-lg-4">
              <div class="order-summary mb-1">
                <h3>{{ translations.shoppingCart }}</h3>
                <h4 v-if="cart && cart.cartItems">
                  <a
                    data-toggle="collapse"
                    href="#order-cart-section"
                    class="expanded"
                    role="button"
                    aria-expanded="true"
                    aria-controls="order-cart-section"
                  >
                    {{ cart.cartItems.length }} {{ translations.articlesInShoppingCart }}
                  </a>
                </h4>
                <div class="collapse show" id="order-cart-section" v-if="cart && cart.cartItems">
                  <table class="table table-mini-cart">
                    <tbody>
                      <tr v-for="item in cart.cartItems" :key="item.id">
                        <td class="product-col">
                          <figure class="product-image-container">
                            <router-link
                              class="product-image"
                              :to="{
                                name: 'Article',
                                params: { id: item.articleId, slug: slugify(item.title) }
                              }"
                            >
                              <Photo
                                :src="`${baseUrl}${item.highlightedImageUrl}`"
                                v-if="item.highlightedImageUrl"
                              />
                              <Photo src="assets/images/no-image.jpg" v-else />
                            </router-link>
                          </figure>
                          <div>
                            <h2 class="product-title">
                              <router-link
                                :to="{
                                  name: 'article',
                                  params: { id: item.id, slug: slugify(item.title) }
                                }"
                              >
                                {{ item.article }}
                              </router-link>
                            </h2>
                            <span class="product-qty">
                              {{ translations.quantity }}: {{ item.quantity }}</span>
                          </div>
                        </td>
                        <td v-if="canViewPrices" class="price-col">
                          {{ item.totalAmount.toFixed(2).replace(".", ",") }} KM
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="custom-table-footer" v-if="canViewPrices">

                    <!-- novi -->
                    <tr>
                        <td>{{ translations.orderTotalAmountWithoutVat }}</td>
                        <td class="text-right" v-if="canViewPrices && cart">
                          {{ cart.totalAmountWithoutVat.toFixed(2) }} KM
                        </td>
                      </tr>
                      <tr>
                        <td>+ {{ translations.tax }}:</td>
                        <td class="text-right"
                        v-if="canViewPrices && cart && cart.cartItems">
                          {{
                            cart.totalAmountVat.toFixed(2)
                          }} KM
                        </td>
                      </tr>
                      <tr style="border-top: 1px solid #ccc;" v-if="canViewPrices && cart &&
                      cart.promoCode && cart.promoCode.discountApplianceType === 1">
                        <td>{{ translations.totalWithVat }}</td>
                        <td class="text-right" v-if="cart && cart.cartItems">
                          {{ (cart.totalAmountWithoutVat + cart.totalAmountVat)
                          .toFixed(2).replace('.', ',') }} KM
                        </td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.promoCode
                        && cart.promoCode.discountApplianceType === 1">
                        <td>- {{ translations.promoCode }}</td>
                        <td class="text-right">-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                      </tr>
                      <tr style="border-top: 1px solid #ccc;" v-if="canViewPrices && cart.giftCard">
                        <td>{{ translations.totalWithVat }}</td>
                        <td class="text-right" v-if="cart && cart.cartItems">
                          {{ (cart.totalAmountWithoutVat + cart.totalAmountVat)
                          .toFixed(2).replace('.', ',') }} KM
                        </td>
                      </tr>
                      <tr v-if="canViewPrices && cart.giftCard">
                        <td>- {{ translations.giftCard }}</td>
                        <td class="text-right">-{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.cartItems"
                      style="border-top: 1px solid #ccc;">
                        <td>{{ translations.totalWithVat }}</td>
                        <td class="text-right">
                          {{ cart.totalAmount.toFixed(2).replace('.', ',') }} KM
                        </td>
                      </tr>
                      <tr v-if="deliveryType === 2">
                        <td>{{ translations.postage }}</td>
                        <td class="text-right">
                          <span v-if="freeShippingEnabled === true &&
                          (freeShippingAmount <= cart.totalAmount || selectedPost.price === 0)">
                            {{ translations.free }}*
                          </span>
                          <span v-else>
                            {{ selectedPost.price.toFixed(2).replace(".", ",") }} KM
                          </span>
                        </td>
                      </tr>
                      <tr v-if="deliveryType === 2">
                        <td>{{ translations.totalOrderAmountWithPostage }}</td>
                        <td class="text-right">
                          <div v-if="freeShippingEnabled === true">
                            <span v-if="freeShippingAmount >= cart.totalAmount">
                              {{(selectedPost.price + cart.totalAmount)
                              .toFixed(2).replace(".", ",") }} KM
                            </span>
                            <span v-else>
                              {{ cart.totalAmount.toFixed(2).replace(".", ",") }} KM
                            </span>
                          </div>
                          <span v-else>
                            {{ (selectedPost.price
                            + cart.totalAmount).toFixed(2).replace(".", ",") }} KM
                          </span>
                        </td>
                      </tr>
                    <!-- kraj novi -->

                      <!-- <tr v-if="canViewPrices && cart && cart.cartItems &&
                        (!cart.promoCode ||
                        (cart.promoCode && cart.promoCode.discountApplianceType !== 1))">
                        <td>Ukupno narudžba (bez PDV):</td>
                        <td class="text-right">{{ (cart.totalAmountWithoutVat
                          + cart.giftCardDiscount).toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.cartItems && cart.promoCode
                        && cart.promoCode.discountApplianceType === 1">
                        <td>Ukupno narudžba (bez PDV):</td>
                        <td class="text-right">{{ (cart.totalAmountWithoutVat + cart.promoDiscount
                          + cart.giftCardDiscount).toFixed(2) }} KM</td>
                        </tr>
                      <tr style="border-bottom: 1px solid #ccc;"
                        v-if="canViewPrices && cart.promoCode
                        && cart.promoCode.discountApplianceType === 1">
                        <td>- {{ translations.promoCode }}</td>
                        <td class="text-right">-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart.promoCode
                        && cart.promoCode.discountApplianceType === 1">
                        <td>{{translations.totalWithoutVat2}}:</td>
                        <td class="text-right">{{ cart.totalAmountWithoutVat.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart.giftCard"
                        style="border-bottom: 1px solid #ccc;" >
                        <td>- {{ translations.giftCard }}</td>
                        <td class="text-right">{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.cartItems && cart.giftCard">
                        <td>{{translations.totalWithoutVat2}}:</td>
                        <td class="text-right">{{ cart.totalAmountWithoutVat.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.cartItems && cart.giftCard"
                        style="border-bottom: 1px solid #ccc;">
                        <td>+ {{ translations.tax }}:</td>
                        <td class="text-right">{{ cart.totalAmountVat.toFixed(2) }} KM</td>
                      </tr>
                      <tr v-if="canViewPrices && cart && cart.cartItems && !cart.giftCard"
                        style="border-bottom: 1px solid #ccc;">
                        <td>+ {{ translations.tax }}:</td>
                        <td class="text-right">{{ cart.totalAmountVat.toFixed(2) }} KM</td>
                      </tr>
                      <tr>
                        <td>{{ translations.totalWithVat }}</td>
                        <td v-if="cart && cart.cartItems"
                          class="text-right">
                          {{cart.totalAmount.toFixed(2) }} KM
                        </td>
                      </tr>
                      <tr v-if="deliveryType === 2">
                        <td>Poštarina</td>
                        <td class="text-right">
                          <span v-if="freeShippingEnabled === true &&
                          (freeShippingAmount <= cart.totalAmount || selectedPost.price === 0)">
                            Besplatno
                          </span>
                          <span v-else>
                            {{ selectedPost.price.toFixed(2).replace(".", ",") }} KM
                          </span>
                        </td>
                      </tr>
                      <tr v-if="deliveryType === 2">
                        <td>Ukupno s poštarinom</td>
                        <td class="text-right">
                          <div v-if="freeShippingEnabled === true">
                            <span v-if="freeShippingAmount >= cart.totalAmount">
                              {{(selectedPost.price + cart.totalAmount)
                              .toFixed(2).replace(".", ",") }} KM
                            </span>
                            <span v-else>
                              {{ cart.totalAmount.toFixed(2).replace(".", ",") }} KM
                            </span>
                          </div>
                          <span v-else>
                            {{ (selectedPost.price
                            + cart.totalAmount).toFixed(2).replace(".", ",") }} KM
                          </span>
                        </td>
                      </tr> -->
                    </tfoot>
                  </table>
                </div>
                <!-- End #order-cart-section -->
              </div>
              <div v-if="cart.promoCode
                && cart.promoCode.discountApplianceType !== 1"
                class="d-flex justify-content-center align-items-center mb-3">
                  <span>
                    {{ translations.promoCodeDiscount }} {{ cart.promoDiscount.toFixed(2) }} KM
                  </span>
              </div>
              <!-- End .order-summary -->
              <div class="checkout-info-box">
                <h3 class="step-title">
                  {{ translations.deliverTo }}:
                  <!-- <a href="#" title="Edit" class="step-title-edit">
                <span class="sr-only">Edit</span>
                <i class="icon-pencil"></i>
              </a> -->
                </h3>
                <address>
                  {{ selectedAddress.user }} <br />
                  {{ selectedAddress.address }} <br />
                  {{ selectedAddress.town }}, {{ selectedAddress.country }},
                  {{ selectedAddress.zipCode }} <br />
                  {{ selectedAddress.country }} <br />
                  {{ selectedAddress.phoneNumber }} <br />
                </address>
              </div>
              <!-- End .checkout-info-box -->
            </div>
            <!-- End .col-lg-4 -->
            <div class="col-lg-8 order-lg-first">
              <div class="checkout-payment">
                <h2 class="step-title">{{ translations.paymentMethod }}:</h2>

                <div
                  class="form-group form-group-custom-control"
                  v-for="method in paymentMethods"
                  :key="method.id"
                >
                  <div class="custom-control custom-radio d-flex">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="radio"
                      :value="method.id"
                      v-model="paymentMethod"
                    />
                    <label class="custom-control-label-radio">{{ method.label }}</label>
                  </div>
                  <!-- End .custom-checkbox -->
                </div>
                <!-- End .form-group -->
                <div class="form-group form-group-custom-control" style="max-width: 100%">
                  <label>{{ translations.note }}: </label>
                  <textarea
                    cols="9"
                    rows="6"
                    class="form-control form-control-sm"
                    v-model="note"
                  ></textarea>
                </div>
                <!-- End .form-group -->
                <div class="checkout-info" v-if="this.financeInfo.total > 0">
                <!-- <h4>
                  <a
                    data-toggle="collapse"
                    href="#checkout-info-section"
                    class="collapsed"
                    role="button"
                    aria-expanded="false"
                    aria-controls="checkout-info-section"
                    >Your Invoice is Overdue (See More)
                  </a>
                </h4>
                <div class="collapse" id="checkout-info-section">
                  <p>Your Invoice is Overdue</p>
                  <router-link class="btn btn-sm btn-outline-secondary" :to="{ name: 'Orders' }">
                    Check Orders
                  </router-link>
                </div> -->

                <div class="checkout-info">
                  <div class="cta-simple cta-border2">
                    <h3 class="font-weight-normal">
                        Vaša <b>valuta</b> je <b>dospjela</b>
                    </h3>
                    <p>Molimo <b>platite Vaše ranije narudžbe</b></p>
                    <router-link class="btn btn-lg btn-primary mt-2"
                    :to="{ name: 'ProfileFinance' }">
                      {{ translations.viewFinances }}
                    </router-link>
                  </div>
                </div>
                <!-- End .collapse -->
              </div>
                <!-- End .form-group -->
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      :value="acceptTerms"
                      v-model="acceptTerms"
                    />
                    <router-link :to="{ name: 'TermsOfService' }" class="ml-2" target="_blank">
                    {{ translations.acceptTermsOfUse }}
                    </router-link>
                  </div>
                  <div class="d-flex">
                    <button @click="currentStep = 1" class="btn btn-primary mx-2">
                      {{ translations.back }}
                    </button>
                    <button
                      @click="placeOrder()"
                      :disabled="!paymentMethod || !acceptTerms"
                      class="btn btn-primary"
                      :class="{ disabled: !paymentMethod || !acceptTerms}"
                    >
                      {{ translations.placeOrder }}
                    </button>
                  </div>
                </div>
                <!-- End .clearfix -->
              </div>
              <!-- End .checkout-payment -->
              <!-- End .checkout-discount -->
            </div>
            <!-- End .col-lg-8 -->
          </div>
          <!-- End .row -->
        </div>
      </div>
      <!-- End .row -->
      <!-- End .row -->
    </div>
    <!-- End .container -->
    <div class="mb-4"></div>
  </div>
</template>

<script>
import config from '@/config';
import api from '@/services/api';
import helpers from '@/services/helpers';
import slugify from '@/filters/slugify';
import { translations, pager } from '@/mixins';

import Photo from '@/components/shared/Image.vue';
import LocalPagination from '@/components/shared/LocalPagination.vue';

const ADDRESS_PAGE_SIZE = 6;

export default {
  name: 'Checkout',
  mixins: [translations, pager],
  components: {
    Photo,
    LocalPagination,
  },
  data() {
    return {
      currentStep: 1,
      paymentMethod: 1,
      firstName: '',
      lastName: '',
      address: '',
      zipCode: '',
      phoneNumber: '',
      countryId: null,
      townId: null,
      selectedAddress: null,
      deliveryType: null, // Osobno preuzimanje
      expressPostId: null,
      note: '',
      acceptTerms: false,
      addressPageSize: ADDRESS_PAGE_SIZE,
      actionName: 'getShippingAddressesFiltered',
    };
  },
  computed: {
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    addresses() {
      return this.$store.getters.getShippingAddressesFiltered;
    },
    countries() {
      return this.$store.getters.getCountries;
    },
    cities() {
      return this.$store.getters.getTowns;
    },
    posts() {
      return this.$store.getters.getExpressPosts;
    },
    financeInfo() {
      return this.$store.getters.getFinanceInfo;
    },
    selectedPost() {
      return this.posts.find((i) => i.id === this.expressPostId);
    },
    baseUrl() {
      return config.baseUrl;
    },
    nextStepDisabled() {
      return !this.deliveryType || !this.selectedAddress;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    paymentMethods() {
      const methods = helpers.paymentTypesArray
        .filter((item) => this.profile.userData.companyPaymentTypes.find((i) => i === item.id));

      if (methods.length === 1) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.paymentMethod = methods[0].id;
      }

      return methods;
    },
    freeShippingAmount() {
      return this.$store.getters.getFreeShippingAmount;
    },
    freeShippingEnabled() {
      return this.$store.getters.getFreeShippingEnabled;
    },
    paginationProps() {
      return {
        pageSize: this.addressPageSize,
      };
    },
  },
  methods: {
    slugify,
    nextStep() {
      this.currentStep = 2;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getTowns() {
      this.$store.dispatch('getTowns', { countryId: this.countryId });
      this.townId = null;
    },
    selectAddress(address) {
      this.selectedAddress = address;
    },
    placeOrder() {
      if (!this.paymentMethod || !this.acceptTerms) {
        return;
      }

      const { deliveryType, expressPostId, paymentMethod } = this;
      const payload = {
        shoppingCartId: this.cart.id,
        shippingAddressId: this.selectedAddress.id,
        paymentType: paymentMethod,
        deliveryType,
        note: this.note,
      };

      if (expressPostId) {
        delete payload.deliveryType;
        payload.expressPostId = expressPostId;
        if (this.freeShippingAmount <= this.cart.totalAmount && this.freeShippingAmount !== 0) {
          payload.transportPrice = 0;
        } else {
          payload.transportPrice = this.posts.find((i) => i.id === expressPostId).price;
        }
      }
      api
        .placeOrder(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getShoppingCart');
          this.$router.push({ name: 'Home' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    setDeliveryType(id) {
      if (id !== 2) this.expressPostId = null;
      this.deliveryType = id;
    },
    calculateDeliveryPrice(post) {
      if (this.freeShippingEnabled === true) {
        return 0;
      }

      const ranges = post.ranges.find((i) => i.minWeight <= this.cart.totalBruttoWeight
      && this.cart.totalBruttoWeight <= i.maxWeight);

      if (!ranges) {
        return null;
      }

      return ranges.deliveryPrice;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.searchConfig.pageSize = this.addressPageSize;
    this.searchConfig.page = 1;
    this.$store.dispatch('getShippingAddressesFiltered', {
      ...this.searchConfig,
      ...this.paginationProps,
    });
    this.$store.dispatch('getFreeShippingEnabled');
    this.$store.dispatch('getFreeShippingAmount');
    this.$store.dispatch('getExpressPosts');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  watch: {
    addresses(value) {
      if (!this.selectedAddress && value?.length > 0) {
        // Select first item from array
        [this.selectedAddress] = value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  cursor: pointer;
}

.shipping-address-box {
  cursor: pointer;
}

.custom-table-footer td{
  border-bottom: none !important;
  padding: 1rem 0;
}
</style>
